<template>
  <div v-if="disabled">
    <slot></slot>
  </div>
  <div v-else @scroll.passive="$emit('scroll', $event)" class="scroll-area" :class="classes" v-bind:style="newStyle">
    <slot></slot>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {EColor} from "~/enums/eColor";
  import {eColors} from "~/modules/gColors/colors";
  import {Logger} from "~/services/logger";

  export default Vue.extend({
    props: {
      color: {
        type: String as () => EColor,
        default: "Grey"
      },
      allowHorizontal: {
        type: Boolean,
        default: false
      },
      maxHeightSubtract: {
        type: Number,
        default: 0
      },
      maxHeightBase: {
        type: String,
        default: '100%'
      },
      keep: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      withInfiniteScroll: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      itemColor: {
        get() {
          if(eColors.includes(this.color)){
            return EColor[this.color];
          } else if(this.color === "") {
            return "";
          } else {
            Logger.errorOnce('ScrollArea', `Color *${this.color}* not available for the scroll bars.`, 'Try one of these values instead:', eColors);
            return "color-unavailable";
          }
        },
        set() {},
      },
      newStyle(): {maxHeight?: string, 'overflow-y'?: string} {
        const styles: Record<string, string> = {}
        if (this.withInfiniteScroll) {
          styles['overflow-y'] = 'hidden'
        }
        if (this.maxHeightSubtract !== 0) {
          styles.maxHeight = `calc(${this.maxHeightBase} - ${this.maxHeightSubtract}px)`
        }
        return styles
      },
      classes(): any {
        return [
          this.itemColor,
          {
            'no-horizontal': !this.allowHorizontal,
            'keep': this.keep
          }
        ];
      }
    },
  });
</script>